/** Papel com acesso master (financeiro, cadastros administrativos, etc.) */
export const STORE_ADMIN_ROLE = 'admin';
/** Papel somente leitura (sem cadastros/edições/exclusões e sem despesas). */
export const STORE_VIEWER_ROLE = 'viewer';

export function isStoreAdmin(role: string | null | undefined): boolean {
  return role === STORE_ADMIN_ROLE;
}

export function isStoreViewer(role: string | null | undefined): boolean {
  return role === STORE_VIEWER_ROLE;
}

export function canStoreWrite(role: string | null | undefined): boolean {
  // Admin e user podem cadastrar/editar; viewer é somente visualização.
  return !!role && !isStoreViewer(role);
}

export function getStoreRoleLabel(role: string | null | undefined): string {
  if (isStoreAdmin(role)) return 'Administrador';
  if (isStoreViewer(role)) return 'Visualizador';
  return 'Usuário';
}
